import { defineStore } from 'pinia'

export const useAppStore = defineStore('app', {
  state: () => ({
    appName: 'Millionaire Trader',
    version: '0.1.0',
    ready: true,
  }),

  getters: {
    title: (state) => state.appName,
  },

  actions: {
    setAppName(name: string) {
      this.appName = name
    },
  },
})
